// ============================================================
// ReportWaterBill — รายงานใบเสร็จค่าน้ำ
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { toFixed, format_date, getStorage, replaceText } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// การจัดเก็บค่าใช้จ่าย
async function report_water_bill(data, iw_number, change_satang, add_debt, reduce_debt) {
  let array = [];
  let index = 1;
  const debt = (add_debt || 0) - (reduce_debt || 0);
  // ปรับปรุงยอดเงิน (เศษสตางค์) มีค่าเดียวต่อ 1 ใบเสร็จ ลงที่แถวแรกเท่านั้น
  const adjust = Number(change_satang ?? data.change_satang ?? 0);
  let adjust_used = false;
  const take_adjust = () => {
    if (adjust_used) return 0;
    adjust_used = true;
    return adjust;
  };
  let add_debt_total = 0;
  let reduce_debt_total = 0;
  // NOTE ค่าเคเบิล/ค่าเบี้ยประกัน ไม่มีคอลัมน์ของตัวเองในรายงานนี้ — รวมอยู่ในคอลัมน์ "ค่าใช้จ่ายอื่นๆ"
  //      (เดิมประกาศตัวแปร cable_cost_total/fire_cost_total ทิ้งไว้แต่ไม่เคยถูกใช้ ลบออกแล้ว)
  let other_income_total = 0;
  let late_payment_total = 0;
  let meter_connect_cost_total = 0;
  let water_bill_total = 0;
  let equipment_maintenance_fee_total = 0;
  let common_expenses_total = 0;
  let waste_cost_total = 0;
  let _total = 0;
  // รายรับอื่นๆ
  if (data.record_other_list?.length > 0) {
    data.water_receipt_list = data.record_other_list;
    for (let item of data.water_receipt_list) {
      let total_other = 0;
      total_other += item.cost || 0;
      other_income_total += item.cost || 0;
      const row_adjust = take_adjust();
      // NOTE เดิมใช้ = (ทับค่าเดิม) ถ้ามีรายรับอื่นๆ หลายรายการ ยอดรวมท้ายตารางจะเหลือแค่รายการสุดท้าย
      const row_total = (item.cost || 0) + row_adjust;
      _total += row_total;
    array.push([
          { text: index, alignment: "center" },
          { text: data.full_name || "-", alignment: "left" },
          { text: "-", alignment: "center" },
          { text: "0", alignment: "center" },
          { text: "0", alignment: "center" },
          { text: "0", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: toFixed(total_other), alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: "0.00", alignment: "center" },
          { text: toFixed(row_adjust), alignment: "center" },
          { text: toFixed(row_total), alignment: "center" },
        ]);
        index += 1; // เดิมไม่เพิ่ม ลำดับทุกแถวจึงเป็น 1
      }
  }else{
    // บิลน้ำ
    data.water_receipt_list = data.transaction_payments?.length > 0 ? data.transaction_payments : data.water_list;
    // เติมวันที่จดมาตรก่อน แล้วเรียงงวดเก่า -> ใหม่ ตั้งแต่ตอนนี้
    // NOTE ตารางถูก sort ตามวันที่อีกครั้งตอนท้าย ถ้าไม่เรียงก่อน ปรับเศษ/เพิ่มลดหนี้ที่ผูกกับ index === 1
    //      จะไปโผล่แถวกลางตาราง (ยอดรวมถูก แต่คนอ่านงง)
    data.water_receipt_list.forEach((item) => {
      item.datetime_create = data.transaction_payments?.length > 0 ? data.water_list.find(x => x.record_water_id === item.record_water_id)?.datetime_create : item.datetime_create;
    });
    data.water_receipt_list.sort((a, b) => new Date(a.datetime_create || 0) - new Date(b.datetime_create || 0));
    for (let item of data.water_receipt_list) {
      if( item.s_add_debt || item.s_cable_cost || item.s_common_expenses || item.s_equipment_maintenance_fee || item.s_fire_cost || item.s_late_payment || item.s_meter_connect_cost || item.s_other_income || item.s_reduce_debt || item.s_waste_cost || item.s_water_bill ){
        
        // s_add_debt
        // s_cable_cost
        // s_common_expenses
        // s_equipment_maintenance_fee
        // s_fire_cost
        // s_late_payment
        // s_meter_connect_cost
        // s_other_income
        // s_reduce_debt
        // s_waste_cost
        // s_water_bill

        let total_final = 0;
        let total_other = 0;
        if(item.s_cable_cost) {
          total_other += item.cable_cost; 
          total_final += item.cable_cost; 
        }
        if(item.s_fire_cost) {
          total_other += item.fire_cost; 
          total_final += item.fire_cost; 
        }
        if(item.s_other_income) {
          total_other += item.other_income; 
          total_final += item.other_income; 
        }
        if(item.s_add_debt) {
          total_final += item.add_debt; 
          add_debt_total += item.add_debt;
        }
        if(item.s_reduce_debt) {
          total_final -= item.reduce_debt; 
          reduce_debt_total += item.reduce_debt;
        }
        if(item.s_late_payment) {
          total_final += item.late_payment || 0; 
          late_payment_total += item.late_payment || 0;
        }
        if(item.s_meter_connect_cost) {
          total_final += item.meter_connect_cost; 
          meter_connect_cost_total += item.meter_connect_cost;
        }
        if(item.s_water_bill) {
          total_final += item.water_bill; 
          water_bill_total += item.water_bill;
        }
        if(item.s_equipment_maintenance_fee) {
          total_final += item.equipment_maintenance_fee; 
          equipment_maintenance_fee_total += item.equipment_maintenance_fee;
        }
        if(item.s_common_expenses) {
          total_final += item.common_expenses; 
          common_expenses_total += item.common_expenses;
        }
        if(item.s_waste_cost) {
          total_final += item.waste_cost; 
          waste_cost_total += item.waste_cost;
        }
        const row_adjust = take_adjust();
        total_final = total_final + (index === 1 ? debt : 0) + row_adjust;
        _total = total_final + _total;
        other_income_total = total_other + other_income_total;
        array.push([
          { text: index, alignment: "center" },
          { text: item.full_name || "-", alignment: "left" },
          { text: item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy") : "-", alignment: "center" },
          { text: item.current_gauge_number || "0", alignment: "center" },
          { text: item.last_gauge_number || "0", alignment: "center" },
          { text: item.unit_used || "0", alignment: "center" },
          { text: item.s_water_bill ? toFixed(item.water_bill) : "0.00", alignment: "center" },
          { text: item.s_equipment_maintenance_fee ? toFixed(item.equipment_maintenance_fee) : "0.00", alignment: "center" },
          { text: item.s_common_expenses ? toFixed(item.common_expenses) : "0.00", alignment: "center" },
          { text: item.s_waste_cost ? toFixed(item.waste_cost) : "0.00", alignment: "center" },
          { text: toFixed(total_other), alignment: "center" },
          { text: toFixed((item.s_add_debt ? item.add_debt : 0) - (item.s_reduce_debt ? item.reduce_debt : 0) + (index === 1 ? debt : 0)), alignment: "center" },
          { text: item.s_meter_connect_cost ? toFixed(item.meter_connect_cost) : "0.00", alignment: "center" },
          { text: item.s_late_payment ? toFixed(item.late_payment || 0) : "0.00", alignment: "center" },
          { text: toFixed(row_adjust), alignment: "center" },
          { text: toFixed(total_final), alignment: "center" },
        ]);

        index += 1;
      }
   }
  }
  array = array.sort((a, b) => {
    let dateA = a[2].text === "-" ? new Date(0) : new Date(a[2].text.split("/").reverse().join("-"));
    let dateB = b[2].text === "-" ? new Date(0) : new Date(b[2].text.split("/").reverse().join("-"));
    return dateA - dateB;
  });
  const docDefinition = {
    content: [
      {
        columns: [
          { text: getStorage("project_name"), alignment: "left", fontSize: 18, bold: true },
          { text: "รายละเอียดใบเสร็จรับเงิน เลขที่ใบเสร็จรับเงิน " + data.iw_number, alignment: "right", fontSize: 14, bold: true },
        ],
      },
      {
        columns: [
          { text: "ห้องเลขที่ " + (data.address_number || "-") + " อาคารเลขที่ " + (data.building || "-"), alignment: "left", fontSize: 14, bold: true },
          { text: "พิมพ์ ณ. วันที่ " + format_date(data.record_date, "DD MMMM YYYY"), alignment: "right", fontSize: 14, bold: true },
        ],
      },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["3.14%", "9.6%", "8.4%", "6.6%", "7.6%", "4%", "5.8%", "8.2%", "5.8%", "4%", "5.8%", "5.8%", "6.4%", "7.4%", "6.4%", "6%"],

          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "ชื่อ-นามสกุล", alignment: "center" },
              { text: "จดมาตรประจำเดือน", alignment: "center" },
              { text: "เลขมาตรครั้งนี้", alignment: "center" },
              { text: "เลขมาตรครั้งก่อน", alignment: "center" },
              { text: "หน่วยใช้", alignment: "center" },
              { text: "ค่าน้ำประปา", alignment: "center" },
              { text: "ค่ารักษาอุปกรณ์น้ำ", alignment: "center" },
              { text: "ค่าส่วนกลาง", alignment: "center" },
              { text: "ค่าขยะ", alignment: "center" },
              { text: "รายรับอื่นๆ", alignment: "center" },
              { text: "เพิ่ม/ลดหนี้", alignment: "center" },
              { text: "ค่าต่อมิเตอร์", alignment: "center" },
              { text: "ค่าปรับชำระล่าช้า", alignment: "center" },
              { text: "ปรับปรุงยอดเงิน", alignment: "center" },
              { text: "รวม", alignment: "center" },
            ],
            ...array,
            ["", "รวมเป็นเงินทั้งสิ้น", "", "", "", "", 
              { text: toFixed(water_bill_total), alignment: "center" }, 
              { text: toFixed(equipment_maintenance_fee_total), alignment: "center" }, 
              { text: toFixed(common_expenses_total), alignment: "center" }, 
              { text: toFixed(waste_cost_total), alignment: "center" }, 
              { text: toFixed(other_income_total), alignment: "center" }, 
              { text: toFixed(add_debt_total - reduce_debt_total + debt), alignment: "center" }, 
              { text: toFixed(meter_connect_cost_total), alignment: "center" }, 
              { text: toFixed(late_payment_total), alignment: "center" },
              { text: toFixed(adjust), alignment: "center" },
              { text: toFixed(_total), alignment: "center" }],
          ],
        },
      },
      { text: " " },
      { text: "ผู้จัดเรียงรายงาน " + getStorage("full_name") + " (ธุรการ การเงิน)", fontSize: 14, alignment: "right", bold: true },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 10, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
    pageOrientation: "landscape",
  };
  let textDocDefinition = await replaceText(docDefinition);
  openPdf(textDocDefinition, "รายชื่อลูกค้าที่ยังไม่โอนกรรมสิทธิ์ห้องชุด บันทึกโอนถึง วันที่ " + format_date(data.record_date, "DD MMMM YYYY") + ".pdf");
}
export { report_water_bill };
